// Mock data for LIINEX INFORMATION SYSTEMS

export const COMPANY = {
  name: "LIINEX INFORMATION SYSTEMS",
  short: "LIS",
  tagline: "ISO Consulting, Training & Certification Partner",
  email: "department@liinexinfo.org",
  phones: ["+91 79828 10821", "+91 98973 88350"],
  address: "36, Signature Street Road, Govind Vihar, Ghaziabad, Uttar Pradesh, India 201013",
  logo: "/lis-logo.png",
  founded: 2012,
  clients: 1500,
  projects: 3200,
  countries: 22,
  consultants: 85,
};

export const NAV = [
  { label: "Home", to: "/" },
  {
    label: "About",
    to: "/about",
    children: [
      { label: "About LIS", to: "/about" },
      { label: "Our Team", to: "/about#team" },
      { label: "Careers", to: "/careers" },
    ],
  },
  {
    label: "Services",
    to: "/services",
    children: [
      { label: "All ISO Consulting", to: "/services" },
      { label: "ISO 9001 : Quality", to: "/services/iso-9001" },
      { label: "ISO 14001 : Environment", to: "/services/iso-14001" },
      { label: "ISO 45001 : Health & Safety", to: "/services/iso-45001" },
      { label: "ISO 27001 : Information Security", to: "/services/iso-27001" },
      { label: "ISO 22000 : Food Safety", to: "/services/iso-22000" },
      { label: "ISO 13485 : Medical Devices", to: "/services/iso-13485" },
      { label: "ISO 42001 : AI Management", to: "/services/iso-42001" },
      { label: "CMMI Level 3 & 5", to: "/services/cmmi-level-3" },
      { label: "CMMC / HIPAA", to: "/services/cmmc" },
      { label: "FSSC 22000 / HACCP / FSSAI", to: "/services/fssc-22000" },
      { label: "SEDEX / SMETA", to: "/services/smeta" },
      { label: "AS9100 / IRIS", to: "/services/as-9100" },
    ],
  },
  {
    label: "Industries",
    to: "/industries",
  },
  {
    label: "Training",
    to: "/training",
  },
  {
    label: "Toolkit",
    to: "/toolkit",
  },
  {
    label: "Case Studies",
    to: "/case-studies",
  },
  {
    label: "Blog",
    to: "/blog",
  },
  {
    label: "Contact",
    to: "/contact",
  },
];

export const SERVICES = [
  {
    slug: "iso-9001",
    code: "ISO 9001",
    title: "Quality Management System",
    tag: "Process Excellence",
    excerpt: "Build a robust QMS that drives consistent quality, customer satisfaction, and continual improvement across your organisation.",
    color: "#c8102e",
    icon: "BadgeCheck",
    benefits: ["Higher customer satisfaction", "Consistent process outputs", "Reduced non-conformities", "Global market access"],
  },
  {
    slug: "iso-14001",
    code: "ISO 14001",
    title: "Environmental Management",
    tag: "Sustainability",
    excerpt: "Embed environmental responsibility into operations with a system that meets regulations and reduces your ecological footprint.",
    color: "#178a5a",
    icon: "Leaf",
    benefits: ["Regulatory compliance", "Reduced waste & emissions", "Cost savings on energy", "Improved brand reputation"],
  },
  {
    slug: "iso-45001",
    code: "ISO 45001",
    title: "Occupational Health & Safety",
    tag: "Workplace Safety",
    excerpt: "Protect your workforce and reduce workplace risks with an internationally recognised OH&S management system.",
    color: "#f59e0b",
    icon: "ShieldCheck",
    benefits: ["Lower incident rates", "Employee wellbeing", "Legal compliance", "Insurance premium reduction"],
  },
  {
    slug: "iso-27001",
    code: "ISO 27001",
    title: "Information Security Management",
    tag: "Cyber & InfoSec",
    excerpt: "Safeguard sensitive data with an ISMS that manages people, process and technology risks against evolving threats.",
    color: "#1e3a8a",
    icon: "Lock",
    benefits: ["Data breach prevention", "Client trust & win-rate", "GDPR/DPDP alignment", "Structured risk management"],
  },
  {
    slug: "iso-22000",
    code: "ISO 22000",
    title: "Food Safety Management",
    tag: "Food & Beverage",
    excerpt: "Deliver safe food through hazard analysis, HACCP-based controls and complete supply chain traceability.",
    color: "#d97706",
    icon: "Utensils",
    benefits: ["Hazard control (HACCP)", "Regulatory compliance", "Supply chain traceability", "Export readiness"],
  },
  {
    slug: "iso-13485",
    code: "ISO 13485",
    title: "Medical Devices QMS",
    tag: "Healthcare",
    excerpt: "Meet the stringent regulatory expectations for medical device design, manufacturing and post-market surveillance.",
    color: "#0891b2",
    icon: "Stethoscope",
    benefits: ["MDR / CDSCO readiness", "Design controls", "Risk management (ISO 14971)", "Post-market surveillance"],
  },
  {
    slug: "iso-17025",
    code: "ISO 17025",
    title: "Testing & Calibration Laboratories",
    tag: "Laboratory",
    excerpt: "Achieve NABL accreditation with a laboratory management system focused on technical competence and reliable results.",
    color: "#7c3aed",
    icon: "FlaskConical",
    benefits: ["NABL accreditation", "Reliable test results", "Method validation", "Measurement uncertainty"],
  },
  {
    slug: "iatf-16949",
    code: "IATF 16949",
    title: "Automotive QMS",
    tag: "Automotive",
    excerpt: "Meet global OEM expectations with an automotive quality management system built for defect prevention and PPAP.",
    color: "#334155",
    icon: "Car",
    benefits: ["OEM tier-1/2 access", "APQP, PPAP, FMEA", "Defect prevention", "Supply chain quality"],
  },
  {
    slug: "iso-22301",
    code: "ISO 22301",
    title: "Business Continuity",
    tag: "Resilience",
    excerpt: "Prepare, respond and recover from disruptions with a business continuity management system.",
    color: "#be123c",
    icon: "Activity",
    benefits: ["Disruption preparedness", "BIA & risk assessment", "Recovery strategies", "Stakeholder confidence"],
  },
  {
    slug: "iso-50001",
    code: "ISO 50001",
    title: "Energy Management",
    tag: "Energy",
    excerpt: "Systematically reduce energy consumption and improve energy performance across your facilities.",
    color: "#059669",
    icon: "Zap",
    benefits: ["Lower energy costs", "Carbon footprint reduction", "BEE / PAT compliance", "Energy performance indicators"],
  },
  {
    slug: "soc-2",
    code: "SOC 2",
    title: "SOC 2 Type I & II",
    tag: "Cloud & SaaS",
    excerpt: "Independent attestation on security, availability, confidentiality, privacy and processing integrity for SaaS providers.",
    color: "#0f766e",
    icon: "CloudCheck",
    benefits: ["Enterprise sales enablement", "Trust Services Criteria", "Vendor risk answers", "Recurring assurance"],
  },
  {
    slug: "gdpr",
    code: "GDPR / DPDP",
    title: "Data Privacy Compliance",
    tag: "Privacy",
    excerpt: "Design privacy-first processes aligned with GDPR, India's DPDP Act and global data protection expectations.",
    color: "#7c2d12",
    icon: "UserCheck",
    benefits: ["DPIA & ROPA", "Consent management", "Breach response", "Cross-border transfers"],
  },
  {
    slug: "iso-42001",
    code: "ISO 42001",
    title: "AI Management System",
    tag: "Artificial Intelligence",
    excerpt: "Govern the responsible development and use of AI with a management system covering risk, transparency and accountability.",
    color: "#4338ca",
    icon: "Cpu",
    benefits: ["Responsible AI governance", "AI risk & impact assessment", "EU AI Act alignment", "Stakeholder trust"],
  },
  {
    slug: "cmmi-level-3",
    code: "CMMI L3",
    title: "CMMI Maturity Level 3 (Defined)",
    tag: "Process Maturity",
    excerpt: "Standardise and define organisation-wide processes for software and service delivery to achieve CMMI Level 3 appraisal.",
    color: "#2563eb",
    icon: "Layers",
    benefits: ["Defined org-wide processes", "Predictable delivery", "Government & global RFP eligibility", "SCAMPI / Benchmark appraisal readiness"],
  },
  {
    slug: "cmmi-level-5",
    code: "CMMI L5",
    title: "CMMI Maturity Level 5 (Optimizing)",
    tag: "Process Maturity",
    excerpt: "Reach the highest CMMI maturity with quantitatively managed, continuously optimised processes and causal analysis.",
    color: "#1d4ed8",
    icon: "TrendingUp",
    benefits: ["Statistical process control", "Causal analysis & resolution", "Continuous optimisation", "Premium client positioning"],
  },
  {
    slug: "cmmc",
    code: "CMMC",
    title: "Cybersecurity Maturity Model Certification",
    tag: "Defence Supply Chain",
    excerpt: "Protect Federal Contract and Controlled Unclassified Information to qualify as a supplier for US Department of Defense contracts.",
    color: "#0f172a",
    icon: "ShieldHalf",
    benefits: ["US DoD contract eligibility", "NIST SP 800-171 alignment", "CUI protection", "Supply chain security"],
  },
  {
    slug: "fssai-license",
    code: "FSSAI",
    title: "FSSAI License & Registration",
    tag: "Food Regulatory",
    excerpt: "End-to-end support for FSSAI basic registration, state and central licences, renewals and compliance for food businesses.",
    color: "#15803d",
    icon: "FileBadge",
    benefits: ["Legal food business operation", "Licence filing & renewal", "Schedule 4 hygiene compliance", "Consumer confidence"],
  },
  {
    slug: "sedex",
    code: "SEDEX",
    title: "Sedex Membership & Ethical Supply Chain",
    tag: "Ethical Trade",
    excerpt: "Register on Sedex and manage responsible sourcing data to meet the ethical expectations of global buyers and retailers.",
    color: "#0e7490",
    icon: "Network",
    benefits: ["Global buyer visibility", "Self-assessment questionnaire support", "Supply chain transparency", "Reduced audit duplication"],
  },
  {
    slug: "smeta",
    code: "SMETA",
    title: "Sedex Members Ethical Trade Audit",
    tag: "Social Compliance",
    excerpt: "Prepare for SMETA 2-Pillar and 4-Pillar audits covering labour standards, health & safety, environment and business ethics.",
    color: "#0369a1",
    icon: "Users",
    benefits: ["Labour standards compliance", "2-Pillar & 4-Pillar readiness", "Corrective action closure", "Retailer acceptance"],
  },
  {
    slug: "hipaa",
    code: "HIPAA",
    title: "HIPAA Compliance",
    tag: "Healthcare Privacy",
    excerpt: "Safeguard protected health information with administrative, physical and technical controls required under HIPAA.",
    color: "#be185d",
    icon: "HeartPulse",
    benefits: ["PHI protection", "Privacy & Security Rule alignment", "Business Associate readiness", "US healthcare market access"],
  },
  {
    slug: "as-9100",
    code: "AS9100",
    title: "Aerospace Quality Management",
    tag: "Aerospace & Defence",
    excerpt: "Meet the stringent quality and safety requirements of aviation, space and defence organisations with AS9100D.",
    color: "#475569",
    icon: "Plane",
    benefits: ["Aerospace OEM approval", "Configuration management", "Product safety & FOD control", "Counterfeit parts prevention"],
  },
  {
    slug: "iris",
    code: "IRIS / ISO 22163",
    title: "Railway Quality Management",
    tag: "Railways",
    excerpt: "Achieve IRIS certification to ISO/TS 22163 and become a qualified supplier to global rail OEMs and operators.",
    color: "#7f1d1d",
    icon: "TrainFront",
    benefits: ["Rail OEM supplier access", "RAMS & LCC management", "Project management controls", "Reduced field failures"],
  },
  {
    slug: "haccp",
    code: "HACCP",
    title: "Hazard Analysis & Critical Control Points",
    tag: "Food Safety",
    excerpt: "Identify, evaluate and control food safety hazards with a Codex-based HACCP plan tailored to your processes.",
    color: "#ea580c",
    icon: "ClipboardCheck",
    benefits: ["Hazard identification", "CCP monitoring", "Export compliance", "Reduced recalls"],
  },
  {
    slug: "gmp",
    code: "GMP",
    title: "Good Manufacturing Practices",
    tag: "Pharma & Manufacturing",
    excerpt: "Ensure products are consistently produced and controlled to quality standards appropriate to their intended use.",
    color: "#0d9488",
    icon: "Factory",
    benefits: ["WHO-GMP / Schedule M alignment", "Contamination control", "Documentation discipline", "Regulatory inspection readiness"],
  },
  {
    slug: "fssc-22000",
    code: "FSSC 22000",
    title: "Food Safety System Certification",
    tag: "GFSI Food Safety",
    excerpt: "GFSI-recognised food safety certification combining ISO 22000, sector PRPs and FSSC additional requirements.",
    color: "#b45309",
    icon: "Utensils",
    benefits: ["GFSI recognition", "Global retailer acceptance", "Food defence & fraud controls", "Version 6 compliance"],
  },
  {
    slug: "gdp",
    code: "GDP",
    title: "Good Distribution Practices",
    tag: "Pharma Logistics",
    excerpt: "Maintain product quality and integrity throughout storage and distribution of pharmaceuticals and medical products.",
    color: "#6d28d9",
    icon: "Truck",
    benefits: ["Cold chain integrity", "Temperature mapping", "Falsified medicine prevention", "Distributor compliance"],
  },
  {
    slug: "fsc",
    code: "FSC",
    title: "Forest Stewardship Council (CoC)",
    tag: "Sustainable Sourcing",
    excerpt: "Demonstrate responsible sourcing of wood, paper and forest-based products through FSC Chain of Custody certification.",
    color: "#166534",
    icon: "Trees",
    benefits: ["FSC label usage", "Chain of custody control", "Green procurement eligibility", "Brand sustainability"],
  },
  {
    slug: "gmp-plus-fsa",
    code: "GMP+ FSA",
    title: "GMP+ Feed Safety Assurance",
    tag: "Animal Feed",
    excerpt: "Secure feed safety across the supply chain with the internationally recognised GMP+ Feed Safety Assurance scheme.",
    color: "#a16207",
    icon: "Wheat",
    benefits: ["Feed safety assurance", "EU market access", "HACCP-based feed controls", "Supply chain monitoring"],
  },
];

export const INDUSTRIES = [
  { name: "Manufacturing", icon: "Factory", desc: "QMS, EMS, OH&S and automotive systems for plants of every scale." },
  { name: "IT & ITES", icon: "MonitorSmartphone", desc: "ISO 27001, SOC 2, ISO 20000 and CMMI aligned delivery." },
  { name: "Healthcare & Pharma", icon: "HeartPulse", desc: "ISO 13485, GMP, NABH and MDR readiness for medical companies." },
  { name: "Food & Beverage", icon: "UtensilsCrossed", desc: "FSSC 22000, HACCP, ISO 22000 across the food value chain." },
  { name: "Automotive", icon: "Car", desc: "IATF 16949, VDA 6.3, APQP and PPAP support for OEM & tier suppliers." },
  { name: "Oil, Gas & Energy", icon: "Fuel", desc: "ISO 50001, API Q1/Q2 and OH&S for high-hazard industries." },
  { name: "Logistics & Warehousing", icon: "Truck", desc: "Process excellence, safety and information security for supply chains." },
  { name: "Education & Training", icon: "GraduationCap", desc: "ISO 21001 EOMS for schools, colleges and training providers." },
  { name: "Banking & Finance", icon: "Landmark", desc: "InfoSec, business continuity and privacy for regulated finance." },
  { name: "Construction & Infra", icon: "HardHat", desc: "Integrated QHSE for construction, real estate and infrastructure." },
  { name: "Laboratories", icon: "FlaskConical", desc: "NABL ISO 17025 and ISO 15189 accreditation consulting." },
  { name: "Government & PSU", icon: "Building2", desc: "Compliance, audits and capability building for public sector." },
];

export const APPROACH = [
  { step: "01", title: "Discover", desc: "Kick-off, scope definition and awareness workshops with your leadership team.", icon: "Search" },
  { step: "02", title: "Gap Assessment", desc: "Baseline audit against the target standard, identify gaps and prioritise actions.", icon: "ClipboardList" },
  { step: "03", title: "Design & Documentation", desc: "Policies, procedures, records and templates tailored to your processes.", icon: "FileText" },
  { step: "04", title: "Implementation", desc: "Roll-out across departments with hands-on hand-holding and training.", icon: "Rocket" },
  { step: "05", title: "Internal Audit & MRM", desc: "Internal audits, management review and corrective action closure.", icon: "ShieldCheck" },
  { step: "06", title: "Certification Support", desc: "Stage 1 & Stage 2 certification audit support with your chosen certifying body.", icon: "Award" },
];

export const STATS = [
  { value: "1,500+", label: "Clients Served", icon: "Users" },
  { value: "3,200+", label: "Projects Delivered", icon: "Briefcase" },
  { value: "22+", label: "Countries", icon: "Globe" },
  { value: "85+", label: "Expert Consultants", icon: "UserCheck" },
];

export const TESTIMONIALS = [
  {
    name: "Rohit Malhotra",
    role: "Quality Head, Auto Components",
    quote: "LIS took us from a fragmented QMS to a fully IATF 16949 certified operation in eight months. Their consultants are practical, on-ground and OEM-savvy.",
    avatar: "https://i.pravatar.cc/120?img=12",
  },
  {
    name: "Neha Verma",
    role: "CTO, HealthTech SaaS",
    quote: "Our ISO 27001 and SOC 2 journey was surprisingly smooth. Their templates saved us months and their auditors are a delight to work with.",
    avatar: "https://i.pravatar.cc/120?img=47",
  },
  {
    name: "Anand Iyer",
    role: "Plant Head, Food Processing",
    quote: "The FSSC 22000 documentation kit and floor training were exactly what our team needed. We cleared the certification audit with zero major NCs.",
    avatar: "https://i.pravatar.cc/120?img=32",
  },
  {
    name: "Dr. Kavita Rao",
    role: "Lab Director, Path Labs",
    quote: "We got NABL accredited within a year of engagement. LIS handled everything from documentation to method validation and PT programs.",
    avatar: "https://i.pravatar.cc/120?img=49",
  },
];

export const TRAININGS = [
  { title: "ISO 9001:2015 Lead Auditor", days: 5, mode: "Classroom / Virtual", level: "Advanced", cert: "IRCA / Exemplar", price: "On request" },
  { title: "ISO 27001:2022 Lead Implementer", days: 5, mode: "Classroom / Virtual", level: "Advanced", cert: "Exemplar Global", price: "On request" },
  { title: "ISO 14001:2015 Internal Auditor", days: 2, mode: "On-site", level: "Intermediate", cert: "LIS Certified", price: "On request" },
  { title: "ISO 45001:2018 Awareness", days: 1, mode: "On-site / Virtual", level: "Beginner", cert: "LIS Certified", price: "On request" },
  { title: "FSSC 22000 v6 Internal Auditor", days: 3, mode: "Classroom", level: "Intermediate", cert: "LIS Certified", price: "On request" },
  { title: "IATF 16949 Core Tools (APQP, PPAP, FMEA, MSA, SPC)", days: 4, mode: "On-site", level: "Advanced", cert: "LIS Certified", price: "On request" },
  { title: "ISO 13485 & MDR Awareness", days: 2, mode: "Classroom", level: "Intermediate", cert: "LIS Certified", price: "On request" },
  { title: "GDPR & DPDP Data Protection Officer", days: 3, mode: "Virtual", level: "Advanced", cert: "LIS Certified", price: "On request" },
];

export const TOOLKITS = [
  { title: "ISO 9001:2015 Documentation Kit", items: "Manuals, 22 procedures, 60+ formats", size: "148 files", format: "MS Word / Excel" },
  { title: "ISO 27001:2022 Toolkit", items: "114 controls, SOA, risk register, policies", size: "210 files", format: "MS Word / Excel" },
  { title: "FSSC 22000 v6 Kit", items: "HACCP plan, PRP, OPRP, records", size: "180 files", format: "MS Word / Excel" },
  { title: "IATF 16949 Core Tools Kit", items: "APQP, PPAP, FMEA, SPC, MSA templates", size: "95 files", format: "MS Excel" },
  { title: "ISO 14001 & 45001 Integrated Kit", items: "Aspects, impacts, HIRA, legal register", size: "135 files", format: "MS Word / Excel" },
  { title: "NABL ISO 17025 Kit", items: "Quality manual, SOPs, uncertainty budgets", size: "170 files", format: "MS Word / Excel" },
];

export const CLIENTS = [
  "Wipro", "HCL", "Minda Corporation", "Varroc Engineering", "Supreme Industries", "Finolex Cables",
  "Sona Comstar", "Shalby Hospitals", "Hikal", "JK Files", "Suprajit Engineering", "Lumax Auto",
];

export const CERT_LOGOS = [
  "IAF", "IAS", "UKAS", "NABCB", "NABL", "IRCA", "Exemplar Global",
];

export const BLOG = [
  {
    slug: "choose-iso-27001-consultant",
    title: "How to choose the best ISO 27001 consultant for your company",
    excerpt: "Six questions every CIO should ask before selecting an ISO 27001 partner in 2026.",
    date: "12 July 2025",
    author: "LIS Editorial",
    tag: "Information Security",
    image: "https://images.unsplash.com/photo-1531403009284-440f080d1e12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxxdWFsaXR5JTIwbWFuYWdlbWVudHxlbnwwfHx8fDE3ODU1NzM1Mzd8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "iso-9001-common-mistakes",
    title: "5 common mistakes companies make during ISO 9001 implementation",
    excerpt: "From copy-paste manuals to poor internal audits - avoid these implementation pitfalls.",
    date: "28 June 2025",
    author: "LIS Editorial",
    tag: "Quality Management",
    image: "https://images.pexels.com/photos/5816300/pexels-photo-5816300.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "fssc-22000-v6-update",
    title: "What's new in FSSC 22000 v6 and how to transition",
    excerpt: "A practical roadmap for food manufacturers moving from v5.1 to v6 before the deadline.",
    date: "09 June 2025",
    author: "LIS Editorial",
    tag: "Food Safety",
    image: "https://images.pexels.com/photos/36765718/pexels-photo-36765718.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "dpdp-act-india",
    title: "India's DPDP Act 2023: what businesses must do now",
    excerpt: "Understand the DPDP Act, its principals, penalties and how ISO 27701 helps you comply.",
    date: "22 May 2025",
    author: "LIS Editorial",
    tag: "Data Privacy",
    image: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMG1lZXRpbmd8ZW58MHx8fHwxNzg1NTczNTM2fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const HERO_IMAGES = [
  "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGNvbnN1bHRpbmd8ZW58MHx8fHwxNzg1NTczNTMwfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMGNvbnN1bHRpbmd8ZW58MHx8fHwxNzg1NTczNTMwfDA&ixlib=rb-4.1.0&q=85",
];

export const ABOUT_IMAGE = "https://images.pexels.com/photos/7693692/pexels-photo-7693692.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
export const CERT_IMAGE = "https://images.unsplash.com/photo-1589330694653-ded6df03f754?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxpc28lMjBjZXJ0aWZpY2F0aW9ufGVufDB8fHx8MTc4NTU3MzUzMHww&ixlib=rb-4.1.0&q=85";
